import ENV from "../env";

const getStripeSessionInvoice = async (stripeAccountId, sessionId) => {
  const response = await fetch(
    `${ENV.firebaseApiUrl}/stripe/${stripeAccountId}/session/${sessionId}/invoice`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Get stripe session invoice failed: " + resData.error);
  }

  return resData;
};

export default getStripeSessionInvoice;
